import {
  CreditCardOutlined,
  DownOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Form, Input, Modal, Row, Tabs, Select } from "antd";

import React, { useContext, useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { AuthContext } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import { Link, useNavigate } from "react-router-dom";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import VisaBtn from "../../assets/images/visa.png";
import BankAcc from "../../assets/images/bank-account.png";
import BankHome from "../../assets/images/bank-home.png";
import Paypal from "../../assets/images/paypal.png";
import TabPane from "antd/es/tabs/TabPane";
import AccountSideNav from "../../components/layout/AccountSideNav";
import Footer from "../../components/layout/Footer";
import Header from "../../components/layout/Header";
import { useAppContext } from "../../context/AppContext";
import { BackArrow } from "./Index";
import lang from "../../helper/langHelper";

import useImageUploader from "../../hooks/useImageUploader";

function Deposite() {
  const { request } = useRequest();
  const { userProfile, setRefreshBalance } = useContext(AuthContext);
  const { isMobile } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const navigate = useNavigate();
  const [withdraw, showWithdraw] = useState(false);
  const [desposit, showDeposit] = useState(false);
  const [list, setList] = useState([]);
  const [amount, setAmount] = useState("");
  const [platformBanks, setPlatformBanks] = useState([]);
  const [userBanks, setUserBanks] = useState([]);
  const [receiptImage, setReceiptImage] = useState(null);
  const { upload, uploading } = useImageUploader();

  const [activeTab, setActiveTab] = useState("ach");

  const handleTabChange = (key) => {
    setActiveTab(key);
    if (key === "bankwire" && platformBanks.length === 0) {
      fetchPlatformBanks();
    }
    if (key === "ach") {
      fetchUserBanks();
    }
  };

  const fetchPlatformBanks = () => {
    setLoading(true);
    request({
      url: "/app/bank-wire/platform-bank-details",
      method: "GET",
      onSuccess: (res) => {
        setLoading(false);
        const listData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setPlatformBanks(listData);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast("Error fetching platform bank details", Severty.ERROR);
      },
    });
  };

  const fetchUserBanks = () => {
    setLoading(true);
    request({
      url: "/app/bank-wire/bank-details",
      method: "GET",
      onSuccess: (res) => {
        setLoading(false);
        const listData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setUserBanks(listData);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast("Error fetching your bank accounts", Severty.ERROR);
      },
    });
  };

  const handleWireDeposit = (values) => {
    if (!receiptImage) {
      ShowToast("Please upload a receipt image", Severty.ERROR);
      return;
    }
    setLoading(true);
    request({
      url: "/app/bank-wire/initiate-deposit",
      method: "POST",
      data: {
        amount: values.amount,
        receiptImage: receiptImage,
      },
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          setActiveTab("creditcard"); // Redirect OR reset
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Error initiating deposit", Severty.ERROR);
      },
    });
  };

  const handleACHDeposit = (values) => {
    const { amount, bankDetailId } = values;
    if (!bankDetailId) {
      ShowToast("Please select a bank account", Severty.ERROR);
      return;
    }
    setLoading(true);
    request({
      url: "/app/ach/initiate-deposit",
      method: "POST",
      data: {
        amount,
        bankDetailId,
      },
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          setActiveTab("ach");
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message || "Error initiating deposit", Severty.ERROR);
      },
    });
  };

  const getTransaction = (id) => {
    setLoading(true);
    request({
      url: `/common/wallet?userId=${id}`,
      method: "GET",
      onSuccess: (res) => {
        setLoading(false);
        const { data } = res;
        if (data.data.length) {
          setList(data.data);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  useEffect(() => {
    if (!userProfile) return;
    fetchUserBanks();
  }, [userProfile, refresh]);

  const [isVisaDropdownOpen, setIsVisaDropdownOpen] = useState(false);

  const handleVisaTypeClick = () => {
    setIsVisaDropdownOpen(!isVisaDropdownOpen);
  };

  const handleInputChange = (e) => {
    setAmount(e.target.value);
  };

  const handleSubmit = () => {
    let payload = {};
    payload.balance = amount;
    request({
      url: "app/payment/add-balance",
      method: "PUT",
      data: payload,
      onSuccess: ({ data, status, message }) => {
        setLoading(false);
        if (status) {
          ShowToast(message, Severty.SUCCESS);
          setAmount();
          setRefreshBalance((prev) => !prev);
        } else {
          ShowToast(message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <>
      <section className="main">
        <Header />

        <div className="account-outers">
          <Row>
            {!isMobile ? <AccountSideNav /> : <BackArrow />}

            <Col span={24} md={16} lg={18} xl={15} className="mx-auto mt-5">
              <div className="">
                <Row gutter={16}>
                  <Col span={24} lg={12}>
                    <Tabs
                      className="deposit-tab"
                      activeKey={activeTab}
                      onTabClick={handleTabChange}
                      tabPosition="left"
                    >
                      {/* <TabPane
                        tab={
                          <div className="deposit-tab-button">
                            <div className="credit-icon">
                              <CreditCardOutlined />
                            </div>
                            <div className="tab-outer-text">
                              <h4>{lang("Credit Card")}</h4>
                              <p>
                                {lang(
                                  "Add any Visa or MasterCard debit or credit card to your OneGold Account."
                                )}
                              </p>
                            </div>
                          </div>
                        }
                        key="creditcard"
                      ></TabPane>

                      <TabPane
                        tab={
                          <div className="deposit-tab-button">
                            <div className="credit-icon">
                              <img src={Paypal} />
                            </div>
                            <div className="tab-outer-text">
                              <h4>PayPal</h4>
                              <p>
                                {lang(
                                  "Securely log in to your PayPal account to buy instantly."
                                )}
                              </p>
                            </div>
                          </div>
                        }
                        key="paypal"
                      ></TabPane> */}

                      <TabPane
                        tab={
                          <div className="deposit-tab-button">
                            <div className="credit-icon">
                              <img src={BankHome} />
                            </div>
                            <div className="tab-outer-text">
                              <h4>Bank Wire</h4>
                              <p>
                                {lang(
                                  "Wire funds directly into your account. Recommended when funding large amounts."
                                )}
                              </p>
                            </div>
                          </div>
                        }
                        key="bankwire"
                      ></TabPane>

                      <TabPane
                        tab={
                          <div className="deposit-tab-button">
                            <div className="credit-icon">
                              <img src={BankAcc} />
                            </div>
                            <div className="tab-outer-text">
                              <h4>{lang("ACH Transfer")}</h4>
                              <p>
                                {lang(
                                  "Instantly request a deposit via ACH from your linked bank account."
                                )}
                              </p>
                            </div>
                          </div>
                        }
                        key="ach"
                      ></TabPane>

                      {/* <TabPane
                        tab={
                          <div className="deposit-tab-button">
                            <div className="credit-icon">
                              <img src={BankAcc} />
                            </div>
                            <div className="tab-outer-text">
                              <h4>{lang("Bank Account")}</h4>
                              <p>
                                {lang(
                                  "Link your bank account to instantly fund your OneGold account and start buying today."
                                )}
                              </p>
                            </div>
                          </div>
                        }
                        key="bankaccount"
                      ></TabPane> */}
                    </Tabs>
                  </Col>
                  <Col span={24} lg={12}>
                    {activeTab === "creditcard" && (
                      <div className="tab-body-credit">
                        <div className="creditcard-cash-balance">
                          <h3 className=" ">{lang("Your Cash Balance")}</h3>
                          <h3>
                            {"$ "}
                            {userProfile?.cashBalance}
                          </h3>
                        </div>
                        <Form layout="vertical" className="row-col mt-3">
                          <Form.Item
                            className="username-form"
                            label="Deposit Amount"
                            name="amount"
                          >
                            <div className="currency-selec-group">
                              <Input
                                placeholder="0.00"
                                className="ant-input ant-input-status-success  buy-sale"
                                type="text"
                              />
                              <div className="currny-names">
                                <span>$</span>
                              </div>
                            </div>
                          </Form.Item>
                          <Form.Item
                            className="username-form"
                            label="Account"
                            name="amount"
                          >
                            <div className="position-relative">
                              <div
                                className="currency-group"
                                onClick={handleVisaTypeClick}
                              >
                                <div className="money-detail">
                                  <img src={VisaBtn} />
                                </div>
                                <div className="currncy-ds">
                                  <div>
                                    <h6>$</h6>
                                    <p>Ending in 8066</p>
                                  </div>
                                  <div className="dawn-angle-er">
                                    <DownOutlined />
                                  </div>
                                </div>
                              </div>
                              {isVisaDropdownOpen && (
                                <div className="visa-dropdawn ">
                                  <div className="currency-group">
                                    <div className="money-detail">
                                      <img src={VisaBtn} />
                                    </div>
                                    <div className="currncy-ds">
                                      <div>
                                        <h6>$</h6>
                                        <p>Ending in 8066</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="add-btn-currency">
                                    <Link>
                                      <PlusCircleOutlined />
                                      Add new account
                                    </Link>
                                  </div>
                                </div>
                              )}
                            </div>
                          </Form.Item>
                        </Form>
                        <div className="money-footer">
                          <Button className="btn">Continue</Button>
                          <p className="withdrawing-error">
                            Please note, if funding an account and subsequently
                            withdrawing funds within 60 days, funds originating
                            from bank ACHs, credit cards and PayPal will be sent
                            to your originating bank account, credit card or
                            PayPal account, regardless of the method you select
                            when withdrawing your funds.
                          </p>
                        </div>
                      </div>
                    )}
                    {activeTab === "paypal" && (
                      <div>
                        <div className="tab-body-credit">
                          <div className="creditcard-cash-balance">
                            <h3 className=" ">Your Cash Balance</h3>
                            <h3>
                              {"$ "}
                              {userProfile?.cashBalance}
                            </h3>
                          </div>
                          <Form layout="vertical" className="row-col mt-3">
                            <Form.Item
                              className="username-form"
                              label="Deposit Amount"
                              name="amount"
                            >
                              <div className="currency-selec-group">
                                <Input
                                  placeholder="0.00"
                                  className="ant-input ant-input-status-success  buy-sale"
                                  type="text"
                                />
                                <div className="currny-names">
                                  <span>$</span>
                                </div>
                              </div>
                            </Form.Item>
                            <Form.Item
                              className="username-form"
                              label="Account"
                              name="amount"
                            >
                              <div className="position-relative">
                                <div
                                  className="currency-group"
                                  onClick={handleVisaTypeClick}
                                >
                                  <div className="money-detail">
                                    <img src={VisaBtn} />
                                  </div>
                                  <div className="currncy-ds">
                                    <div>
                                      <h6>$</h6>
                                      <p>Ending in 8066</p>
                                    </div>
                                    <div className="dawn-angle-er">
                                      <DownOutlined />
                                    </div>
                                  </div>
                                </div>
                                {isVisaDropdownOpen && (
                                  <div className="visa-dropdawn ">
                                    <div className="currency-group">
                                      <div className="money-detail">
                                        <img src={VisaBtn} />
                                      </div>
                                      <div className="currncy-ds">
                                        <div>
                                          <h6>$</h6>
                                          <p>Ending in 8066</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="add-btn-currency">
                                      <Link>
                                        <PlusCircleOutlined />
                                        Add new account
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </Form.Item>
                          </Form>
                          <div className="money-footer">
                            <Button className="btn">Continue</Button>
                            <p className="withdrawing-error">
                              Please note, if funding an account and
                              subsequently withdrawing funds within 60 days,
                              funds originating from bank ACHs, credit cards and
                              PayPal will be sent to your originating bank
                              account, credit card or PayPal account, regardless
                              of the method you select when withdrawing your
                              funds.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === "bankwire" && (
                      <div className="tab-body-credit">
                        <div className="creditcard-cash-balance mb-4">
                          <h3 className=" " style={{ color: '#fff' }}>Platform Bank Details</h3>
                          <p style={{ color: '#fff' }}>Please transfer your funds to one of the following accounts and upload the receipt below.</p>
                        </div>

                        <div className="bank-details-container mb-4" style={{
                          display: 'flex',
                          overflowX: 'auto',
                          gap: '12px',
                          paddingBottom: '10px'
                        }}>
                          {platformBanks.map((bank, index) => (
                            <div key={index} className="bank-info-card" style={{
                              background: '#1a1a1a',
                              border: '1px solid #333',
                              padding: '12px',
                              borderRadius: '8px',
                              boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                              minWidth: '230px',
                              flex: '0 0 auto',
                              fontSize: '12px'
                            }}>
                              <h6 style={{ color: '#65C953', marginBottom: '8px', fontSize: '13px', fontWeight: '600' }}>{bank.bankName}</h6>
                              <Row gutter={[8, 4]}>
                                <Col span={24}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                                    <span style={{ color: '#888' }}>Acc Name:</span>
                                    <span style={{ color: '#fff', fontWeight: '500' }}>{bank.accountName}</span>
                                  </div>
                                </Col>
                                <Col span={24}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                                    <span style={{ color: '#888' }}>Acc Number:</span>
                                    <span style={{ color: '#fff', fontWeight: '500' }}>{bank.accountNumber}</span>
                                  </div>
                                </Col>
                                {bank.iban && (
                                  <Col span={24}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                                      <span style={{ color: '#888' }}>IBAN:</span>
                                      <span style={{ color: '#fff', fontWeight: '500' }}>{bank.iban}</span>
                                    </div>
                                  </Col>
                                )}
                                {bank.swiftCode && (
                                  <Col span={24}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '8px' }}>
                                      <span style={{ color: '#888' }}>Swift/BIC:</span>
                                      <span style={{ color: '#fff', fontWeight: '500' }}>{bank.swiftCode}</span>
                                    </div>
                                  </Col>
                                )}
                              </Row>
                            </div>
                          ))}
                        </div>

                        <hr style={{ border: '0', borderTop: '1px solid #333', margin: '30px 0' }} />

                        <Form layout="vertical" className="row-col" onFinish={handleWireDeposit}>
                          <Form.Item
                            label={<span style={{ color: '#fff', fontSize: '16px' }}>Deposit Amount</span>}
                            name="amount"
                            rules={[{ required: true, message: 'Please enter the amount' }]}
                          >
                            <div className="currency-selec-group">
                              <Input
                                placeholder="0.00"
                                className="ant-input buy-sale"
                                type="number"
                                style={{
                                  height: '50px',
                                  background: '#1a1a1a',
                                  border: '1px solid #333',
                                  color: '#fff'
                                }}
                              />
                              <div className="currny-names" style={{ height: '50px' }}>
                                <span>$</span>
                              </div>
                            </div>
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ color: '#fff', fontSize: '16px' }}>Upload Receipt</span>}
                            required
                          >
                            <div className="custom-file-upload" style={{
                              border: '1px dashed #333',
                              padding: '20px',
                              borderRadius: '8px',
                              textAlign: 'center',
                              background: '#1a1a1a'
                            }}>
                              <Input
                                type="file"
                                id="wire-receipt-upload"
                                style={{ display: 'none' }}
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    try {
                                      const res = await upload(file);
                                      setReceiptImage(res);
                                      ShowToast("Receipt uploaded successfully", Severty.SUCCESS);
                                    } catch (err) {
                                      ShowToast("Upload failed", Severty.ERROR);
                                    }
                                  }
                                }}
                              />
                              <Button
                                type="dashed"
                                onClick={() => document.getElementById('wire-receipt-upload').click()}
                                loading={uploading}
                                style={{ color: '#fff', background: 'transparent' }}
                              >
                                {receiptImage ? "Change Receipt" : "Click to Upload Receipt"}
                              </Button>
                              {receiptImage && (
                                <div style={{ marginTop: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                  <span style={{ color: '#65C953', marginBottom: '8px', display: 'block' }}>✓ Receipt Uploaded Successfully:</span>
                                  <img 
                                    src={receiptImage} 
                                    alt="Receipt Preview" 
                                    style={{ 
                                      maxWidth: '180px', 
                                      maxHeight: '180px', 
                                      borderRadius: '8px', 
                                      border: '1px solid #333',
                                      boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
                                      objectFit: 'contain'
                                    }} 
                                  />
                                </div>
                              )}
                            </div>
                          </Form.Item>

                          <div className="money-footer mt-4">
                            <Button
                              className="btn"
                              htmlType="submit"
                              loading={loading || uploading}
                              style={{
                                width: '100%',
                                height: '50px',
                                fontSize: '18px',
                                fontWeight: '600'
                              }}
                            >
                              Submit Deposit Request
                            </Button>
                          </div>
                        </Form>
                      </div>
                    )}
                    {activeTab === "bankaccount" && (
                      <div>
                        <div className="tab-body-credit">
                          <div className="creditcard-cash-balance">
                            <h3>Your Cash Balance</h3>
                            <h3>
                              {"$ "}
                              {userProfile?.cashBalance}
                            </h3>
                          </div>
                          <Form layout="vertical" className="row-col mt-3">
                            <Form.Item
                              className="username-form"
                              label="Deposit Amount"
                              name="amount"
                            >
                              <div className="currency-selec-group">
                                <Input
                                  placeholder="0.00"
                                  className="ant-input ant-input-status-success buy-sale"
                                  type="text"
                                  value={amount}
                                  onChange={handleInputChange}
                                />
                                <div className="currny-names">
                                  <span>$</span>
                                </div>
                              </div>
                            </Form.Item>
                          </Form>
                          <div className="money-footer">
                            <Button className="btn" onClick={handleSubmit}>
                              Continue
                            </Button>
                            <p className="withdrawing-error">
                              Please note, if funding an account and
                              subsequently withdrawing funds within 60 days,
                              funds originating from bank ACHs, credit cards and
                              PayPal will be sent to your originating bank
                              account, credit card or PayPal account, regardless
                              of the method you select when withdrawing your
                              funds.
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                    {activeTab === "ach" && (
                      <div className="tab-body-credit">
                        <div className="creditcard-cash-balance mb-4">
                          <h3 className=" " style={{ color: '#fff' }}>ACH Deposit</h3>
                          <p style={{ color: '#fff' }}>Select a linked bank account and enter the amount to transfer via ACH.</p>
                        </div>
                        <Form layout="vertical" className="row-col" onFinish={handleACHDeposit}>
                          <Form.Item
                            label={<span style={{ color: '#fff', fontSize: '16px' }}>Select Bank Account</span>}
                            name="bankDetailId"
                            rules={[{ required: true, message: 'Please select a bank account' }]}
                          >
                            <Select
                              placeholder="Select a bank account"
                              style={{
                                height: '50px',
                                background: '#1a1a1a',
                                border: '1px solid #333',
                                color: '#fff'
                              }}
                              className="ach-select"
                              dropdownStyle={{ background: '#1a1a1a', border: '1px solid #333' }}
                            >
                              {userBanks.map((bank, index) => (
                                <Select.Option key={index} value={bank._id}>
                                  <span style={{ color: '#fff' }}>{bank.bankName} - {bank.accountName} (Ending in {bank.accountNumber ? bank.accountNumber.slice(-4) : ""})</span>
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>

                          <Form.Item
                            label={<span style={{ color: '#fff', fontSize: '16px' }}>Deposit Amount</span>}
                            name="amount"
                            rules={[{ required: true, message: 'Please enter the amount' }]}
                          >
                            <div className="currency-selec-group">
                              <Input
                                placeholder="0.00"
                                className="ant-input buy-sale"
                                type="number"
                                style={{
                                  height: '50px',
                                  background: '#1a1a1a',
                                  border: '1px solid #333',
                                  color: '#fff'
                                }}
                              />
                              <div className="currny-names" style={{ height: '50px' }}>
                                <span>$</span>
                              </div>
                            </div>
                          </Form.Item>

                          <div className="money-footer mt-4">
                            <Button
                              className="btn"
                              htmlType="submit"
                              loading={loading}
                              style={{
                                width: '100%',
                                height: '50px',
                                fontSize: '18px',
                                fontWeight: '600'
                              }}
                            >
                              Submit ACH Deposit Request
                            </Button>
                          </div>
                        </Form>
                      </div>
                    )}
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>

        {withdraw && (
          <Withdraw
            show={withdraw}
            hide={() => showWithdraw(false)}
            refresh={() => setRefresh((prev) => !prev)}
          />
        )}

        {desposit && (
          <Desposit
            show={desposit}
            hide={() => showDeposit(false)}
            refresh={() => setRefresh((prev) => !prev)}
          />
        )}
      </section>
      <Footer />
    </>
  );
}

const Withdraw = ({ show, hide, refresh }) => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (show) {
      fetchBankAccounts();
    }
  }, [show]);

  const fetchBankAccounts = () => {
    request({
      url: "/app/bank-wire/bank-details",
      method: "GET",
      onSuccess: (res) => {
        const listData = Array.isArray(res.data) ? res.data : (res.data?.data || []);
        setBankAccounts(listData);
      },
    });
  };

  const onFinish = (values) => {
    const { amount, bankDetailId } = values;

    setLoading(true);

    request({
      url: "/app/bank-wire/initiate-withdrawal",
      method: "POST",
      data: { amount, bankDetailId },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          form.resetFields();
          if (refresh) refresh();
          hide();
          ShowToast(data.message, Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message || "Error initiating withdrawal", Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      className="modal01"
      onCancel={hide}
      title="Withdraw to Bank"
      open={show}
      footer={false}
    >
      <div>
        <Form
          layout="vertical"
          className="row-col"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            className="username-form"
            label="Amount"
            name="amount"
            rules={[{ required: true, message: "Please enter the amount!" }]}
          >
            <Input className="form-of-type" type="number" />
          </Form.Item>

          <Form.Item
            className="username-form"
            label="Select Bank Account"
            name="bankDetailId"
            rules={[{ required: true, message: "Please select a bank account!" }]}
          >
            <Select placeholder="Select a bank account" className="form-of-type">
              {bankAccounts.map((bank) => (
                <Select.Option key={bank._id} value={bank._id}>
                  {bank.bankName} - {bank.accountNumber}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <div className="mt-3 mx-auto text-center">
            <Form.Item className="username-form">
              <Button loading={loading} htmlType="submit">
                Submit Request
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

const Desposit = ({ show, hide, refresh }) => {
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const onFinish = (values) => {
    const { cashBalance } = values;

    setLoading(true);

    request({
      url: "/app/auth/withdrawOrAdd ",
      method: "PUT",
      data: { balanceStatus: "add", cashBalance },
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          form.setFieldsValue({ cashBalance: null });
          if (refresh) refresh();
          ShowToast(data.message, Severty.SUCCESS);
          hide();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      className="modal01"
      onCancel={hide}
      title="Add Amount"
      open={show}
      footer={false}
    >
      <div>
        <Form
          layout="vertical"
          className="row-col"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            className="username-form"
            label="Amount"
            name="cashBalance"
            rules={[{ required: true, message: "Please enter the amount!" }]}
          >
            <Input className="form-of-type" type="text" />
          </Form.Item>

          <div className="mt-3 mx-auto text-center">
            <Form.Item className="username-form">
              <Button loading={loading} htmlType="submit">
                Submit
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

export default Deposite;
